import { BrowserRouter, Route, Routes } from "react-router-dom"
import "./App.css"
import LandingPage from "./pages/LandingPage"

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* One route for every step so the page keeps its state as the URL changes */}
        <Route path="/*" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
